import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from '../button/button';

@Component({
  selector: 'app-batch-created-modal',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './batch-created-modal.html',
  styleUrl: './batch-created-modal.css'
})
export class BatchCreatedModal {
  @Output() cancel = new EventEmitter<void>();
  @Output() createMore = new EventEmitter<void>();

  onCancel() { this.cancel.emit(); }
  onCreateMore() { this.createMore.emit(); }
}